import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState, useContext } from 'react';
import { Route } from 'react-router-dom';
import BasicUserConfig from '../components/userConfig/BasicUserConfig';
import LocalizationContext from '../contexts/LocalizationContext';
export var useLoruleNav = function useLoruleNav(tabs, hiddenRoutes, userConfig) {
  var getDefaultUserConfig = function getDefaultUserConfig() {
    return {
      name: localizedStrings.lorule.userProfile.edit,
      roles: null,
      path: '/edit-profile',
      component: /*#__PURE__*/React.createElement(BasicUserConfig, null)
    };
  };

  var localizedStrings = useContext(LocalizationContext);

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      routes = _useState2[0],
      setRoutes = _useState2[1];

  var _useState3 = useState(getDefaultUserConfig()),
      _useState4 = _slicedToArray(_useState3, 2),
      configComponent = _useState4[0],
      setConfigComponent = _useState4[1];

  useEffect(function () {
    var config; // Collect all LoruleNav tabs into routes

    for (var i = 0; i < tabs.length; i++) {
      var menuItem = tabs[i];

      var _loop = function _loop(j) {
        var componentConfig = menuItem.components[j];
        var newRoute = /*#__PURE__*/React.createElement(Route, {
          path: componentConfig.path,
          exact: !!componentConfig.exact,
          key: componentConfig.path,
          component: function component() {
            return componentConfig.component;
          }
        });
        routes.push(newRoute);
      };

      for (var j = 0; j < menuItem.components.length; j++) {
        _loop(j);
      }
    } // Add in extra routes provided by the app


    if (hiddenRoutes) {
      hiddenRoutes.forEach(function (routeConfig) {
        var route = /*#__PURE__*/React.createElement(Route, {
          path: routeConfig.path,
          exact: !!routeConfig.exact,
          key: routeConfig.path,
          component: function component() {
            return routeConfig.component;
          }
        });
        routes.push(route);
      });
    }

    setRoutes(routes); // Uses custom user config if given

    if (userConfig) {
      config = userConfig;
      var route = /*#__PURE__*/React.createElement(Route, {
        path: userConfig.path,
        exact: !!userConfig.exact,
        key: userConfig.path,
        component: function component() {
          return userConfig.component;
        }
      });
      routes.push(route);
    } else {
      var defaultConfig = getDefaultUserConfig();
      config = defaultConfig;

      var _route = /*#__PURE__*/React.createElement(Route, {
        path: defaultConfig.path,
        key: defaultConfig.path,
        component: function component() {
          return defaultConfig.component;
        }
      });

      routes.push(_route);
    }

    setConfigComponent(config);
    setRoutes(routes);
  }, [localizedStrings.getLanguage()]);
  return {
    tabs: tabs,
    routes: routes,
    configComponent: configComponent
  };
};